import { useEffect } from 'react';

// Spec §0.11 rule #7: every dialog/modal/slide-over closes on Escape.
// Single hook, reused by every dismissable surface.
export function useEscapeKey(active: boolean, onEscape: () => void): void {
  useEffect(() => {
    if (!active) return;
    function handler(e: KeyboardEvent): void {
      if (e.key === 'Escape') {
        e.stopPropagation();
        onEscape();
      }
    }
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [active, onEscape]);
}
